module.exports = __webpack_public_path__ + "box.png?bb0e83f8e2b0a11722309e40552d2bb3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/box.png
// module id = 91
// module chunks = 0